import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { KwTileComponent } from './kw-tile.component';

@NgModule({
  imports: [CommonModule, FlexLayoutModule.withConfig({ useColumnBasisZero: false }), SharedModule],
  declarations: [KwTileComponent],
  exports: [KwTileComponent]
})
export class KwTileModule {}
